import React from "react";
import { SplitButton } from "primereact/splitbutton";

const DropdownButton = ({ items, label, ...props }) => {
  return (
    <SplitButton
      {...props}
      label={label}
      outlined={true}
      model={items}
      size="small"
      type="button"
    />
  );
};

export default DropdownButton;
